Ext.define('SA.EditPanel', {
    alias: 'widget.edit-panel',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-edit-panel',

    initComponent() {
        this.items = [
            {
                xtype: 'edit-panel-header',
                title: this.title,
                selectionButtons: this.headerSelectionButtons
            },
            ...Ext.Array.from(this.subheader),
            this.enabledSection,
            ...this.disabledSections
        ];

        this.callParent();
    }
});